import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import 'react-toastify/dist/ReactToastify.css';


const Quiz = ({ quiz }) => {
  
  const { options, question,correctAnswer } = quiz;
 
  const[correct, setCorrect] = useState(false);
  const[isshow, setIsshow] = useState(false);

  const handleQuiz = (answer, correctAns) => { 
    if(answer == correctAns){
      toast.info('Info: Right Ans!', { autoClose: 500 })
    }
    else{
      toast.info('Info: False Ans!', { autoClose: 500 })
    }

   }
   if(isshow){
    toast.success(`${correctAnswer}`)
   }

  return (
    <div className="">
      <div className="fool">
      <span onClick={() => setIsshow(true)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
</svg>
</span>
        {<h1 className="py-4 text-2xl ">Quiz: {question}</h1>}
        
        {options.map((option, i) => (
          <div className="py-12 p-4  h-4 bg-gray-400 my-4 ">
            {i}.<button onClick={()=>handleQuiz(option, correctAnswer)}>{option}</button>
            <ToastContainer></ToastContainer>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Quiz;
